/**
 * Vault: the organisation's file and knowledge layer (Weco BRD §11, §43).
 *
 * Everything starts private to its owner. Access is granted by sharing a file
 * or a folder (and so everything inside it) with a person, a team, or the
 * whole organisation. Mochi, the personal companion, is Vault's AI: it can
 * only ever read what the person talking to it can read (BRD §31).
 */
export const VAULT_ROLES = ['VIEWER', 'EDITOR'];
export const VAULT_GRANTEE_TYPES = ['USER', 'TEAM', 'ORG'];
/**
 * Storage tiers (VA-1). Each person has one; the quota for each tier is set
 * by the operator (VAULT_QUOTA_GB_*), so it can follow the pricing plan.
 */
export const VAULT_TIERS = ['BASIC', 'STANDARD', 'PREMIUM', 'UNLIMITED'];
export const VAULT_REVIEW_LANGUAGES = ['ar', 'en'];
/**
 * Item references Mochi writes in replies: [[file:ID|Name]], [[folder:ID|Name]],
 * or with where in the file the fact came from: [[file:ID|Name|Page 3]] (VA-8).
 */
export const VAULT_REFERENCE_PATTERN = /\[\[(file|folder):([A-Za-z0-9_-]{6,64})\|([^\]|\n]{1,200})(?:\|([^\]|\n]{1,60}))?\]\]/g;
//# sourceMappingURL=vault.js.map